module.exports = __webpack_public_path__ + "static/media/ekspert_boczne.1ca46a73.jpg";